import {
  PAC_ROUTE,
  PAC_CONFIGURATION_ROUTE,
  PAC_CONFIGURATIONS_ROUTE,
  PAC_SAVED_LISTS_ROUTE
} from '@/router/routeNames'

const Pac = () => import(/* webpackChunkName: "pac" */ '@/views/Pac.vue')

// Configurations
const ConfigurationsTable = () => import(
  /* webpackChunkName: "pac" */ '@/components/pac/configurations/ConfigurationsTable.vue'
)
const ConfigurationsHeader = () => import(
  /* webpackChunkName: "pac" */ '@/components/pac/configurations/ConfigurationsHeader.vue'
)

// Configuration
const Configuration = () => import(/* webpackChunkName: "pac" */ '@/components/pac/configuration/Configuration.vue')
const BackBtn = () => import(/* webpackChunkName: "pac" */ '@/packages/@mi-components/MiBackBtn')

const SavedLists = () => import(/* webpackChunkName: "pac" */ '@/components/pac/saved-lists/SavedLists.vue')

const routes = [
  {
    path: PAC_ROUTE.path,
    name: PAC_ROUTE.name,
    component: Pac,
    redirect: {
      name: PAC_CONFIGURATIONS_ROUTE.name
    },
    meta: {
      authorities: ['PAC_ACCESS'],
      isAppHeaderVisible: true,
      isAuthRequired: true,
      title: PAC_ROUTE.title
    },
    children: [
      {
        path: PAC_CONFIGURATIONS_ROUTE.path,
        name: PAC_CONFIGURATIONS_ROUTE.name,
        components: {
          default: ConfigurationsTable,
          header: ConfigurationsHeader
        }
      },
      {
        path: PAC_SAVED_LISTS_ROUTE.path,
        name: PAC_SAVED_LISTS_ROUTE.name,
        components: {
          default: SavedLists,
          header: BackBtn
        },
        props: {
          header: {
            to: PAC_CONFIGURATIONS_ROUTE.name
          }
        }
      },
      {
        path: PAC_CONFIGURATION_ROUTE.path,
        name: PAC_CONFIGURATION_ROUTE.name,
        components: {
          default: Configuration,
          header: BackBtn
        },
        props: {
          default: route => ({ configurationId: route.params.id }),
          header: {
            to: PAC_CONFIGURATIONS_ROUTE.name
          }
        }
      }
    ]
  }
]

export default routes
